<div class="header-section-div">
  <div class="space-v-m" *ngIf="hasCover; else noCover">
    <img [src]="coverToDisplay" alt="{{ recipe.title }}" width="88px" height="88px" />
  </div>
  <ng-template #noCover>
    <div class="space-v-m">
      <img src="assets/images/no-picture.jpg" alt="{{ recipe.title }}" width="88px" height="88px" />
    </div>
  </ng-template>
  <div class="title-container">
    <div>
      <span *ngFor="let course of courseTypesNameList; let isLast = last"> {{ course }}{{ isLast ? '' : ', ' }} </span>
    </div>
    <h1>{{ formTitle }} {{ translationLangs.source | uppercase }} / {{ translationLangs.target | uppercase }}</h1>
    <mat-chip-listbox>
      <mat-chip>{{ 'TOP_RECIPE' | translate }}{{ recipe.topRecipeId }} </mat-chip>
      <mat-chip *ngIf="recipe && recipe.brand">
        {{ recipe.recipeType === 'UGC' ? 'UGC' : recipe.brand.name }}
      </mat-chip>
      <mat-chip>{{ domainName }} </mat-chip>
      <mat-chip>{{ marketName }} </mat-chip>
      <mat-chip>{{ langName }} </mat-chip>
    </mat-chip-listbox>
  </div>

  <div class="header-actions">
    <app-recipes-translation-header-actions
      [buttonsDisabled]="buttonsDisabled"
      (translationApproved)="onTranslationApproved($event)"
    ></app-recipes-translation-header-actions>
  </div>
</div>
